// extracted by mini-css-extract-plugin
export var dark = "Button-module--dark--1daac";
export var link = "Button-module--link--484f3";
export var linkWrapper = "Button-module--linkWrapper--64f22";
export var primary = "Button-module--primary--36c75";
export var root = "Button-module--root--c0c43";
export var secondary = "Button-module--secondary--110d4";
export var stableDarkColor = "Button-module--stableDarkColor--47d7b";